<template>
  <div class="row">
    <h2>Stitch Questions</h2>
    <div style="padding-bottom:10px;font-weight:700;">
      Total Questions selected : {{ markedQuestionIDs.length }}
    </div>
    <div>
      <button class="button-green p-3 px-6 mb-4" @click="stitchFinalQuestions">
        {{ mode === "add" ? "Add Stitching" : "Update Stitching" }}
      </button>
    </div>
    <div class="row">
      <div class="small-4 columns">Name</div>
      <div class="small-8 columns"><input v-model="name" type="text" /></div>
    </div>
    <div class="row">
      <div class="small-4 columns">Time Allocated</div>
      <div class="small-8 columns">
        <input v-model="time_allocated" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">Is Time Bound</div>
      <div class="small-8 columns">
        <input v-model="is_time_bound" type="checkbox" />
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">Tags</div>
      <div class="small-8 columns">
        <VueSelect
          v-model="selectedTags"
          :options="tagOptions"
          label="name"
          multiple
        />
      </div>
    </div>
    <div class="row mt-8 mb-6">
      <div class="small-4 columns">Add Company</div>

      <div class="small-8 columns">
        <VueSelect
          v-model="selectedCompany"
          :options="companyOptions"
          label="name"
          multiple
          :closeOnSelect="false"
        />
      </div>
    </div>

    <div class="row my-8">
      <div class="small-4 columns">Question Bank Tags</div>
      <div class="small-8 columns">
        <VueSelect
          v-model="selectedQuestionBankTags"
          :options="questionBankTagOptions"
          label="name"
          multiple
        />
      </div>
    </div>

    <div class="row mt-8">
      <div class="small-4 columns">Select Proficiency Level</div>

      <div class="small-8 columns">
        <VueSelect
          v-model="questionProficiency"
          :options="questionProficiencyOptions"
        />
      </div>
    </div>

    <div
      v-if="selectedQuestions.length > 0 && mode === 'edit'"
      class="selected-questions"
    >
      <h2 class="text-center my-8">Selected Questions</h2>
      <div
        v-for="(question, i) in selectedQuestions"
        :key="i + '-selected-questions'"
      >
        <div
          class="row paddd-down"
          :style="
            checkIfIDExistsInArray(question.question_id)
              ? 'background-color:#aeefae'
              : ''
          "
        >
          <div class="small-6 columns">
            <div>
              {{ i + 1 }} .
              {{ question.title ? question.title : question.content }}
            </div>
          </div>
          <div class="small-6 columns">
            <span
              class="mcq-mark-button link"
              @click="markQuestionForStitching(question.question_id, question)"
              >Mark</span
            >
            <span
              class="mcq-unmark-button link"
              @click="
                unmarkQuestionForStitching(question.question_id, question)
              "
              >Unmark</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="my-8 text-center font-bold text-gray-300">
      <h2 class="text-3xl">All Questions</h2>
      <div class="flex flex-row justify-center">
        <div class="mx-3">
          <p class="mb-2">Select per page result</p>
          <select v-model="per_page" selected="20" @change="getMCQs">
            <option disabled="true">Question type</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="70">70</option>
            <option value="100">100</option>
          </select>
        </div>
        <div class="mx-3">
          <label>Enter question tag id</label>
          <div class="flex flex-row mt-2 w-full">
            <VueSelect
              v-model="search_by_qtag"
              :options="tagOptions"
              label="name"
              class="w-full"
              multiple
              @input="getMCQs"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="page-numbers overflow-auto flex flex-row mb-4">
        <div v-for="num in totalPages" :key="num + '-question-page'">
          <div
            class="p-1 border rounded-full flex-shrink-1 m-1 mb-4 page-number"
            :class="page === num ? 'bg-grey-darker text-white' : 'bg-white'"
            @click="gotoPage"
          >
            {{ num }}
          </div>
        </div>
      </div>
      <h3 class="text-center mb-4 border-b pb-3">
        Page {{ page }} of {{ totalPages }} (stitched MCQ questions are listed
        first)
      </h3>
    </div>
    <div class="mb-10">
      <div v-for="(question, i) in questions" :key="i + '-question'">
        <div
          class="row paddd-down border-b"
          :style="
            checkIfIDExistsInArray(question.id)
              ? 'background-color:#aeefae'
              : ''
          "
        >
          <div class="small-6 columns">
            <div>
              {{ i + 1 }} .
              {{ question.name ? question.name : question.content }}
            </div>
          </div>
          <div class="small-6 columns">
            <span
              class="mcq-mark-button link"
              @click="markQuestionForStitching(question.id, question)"
              >Mark</span
            >
            <span
              class="mcq-unmark-button link"
              @click="unmarkQuestionForStitching(question.id, question)"
              >Unmark</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  data() {
    return {
      allAnswers: [],
      page: 1,
      per_page: 20,
      search_by_qtag: "",
      url: "",
      totalPages: 0,
      questions: [],
      markedQuestionIDs: [],
      time_allocated: 0,
      is_time_bound: false,
      // //
      name: "",
      id: "",
      mode: "",
      selectedQuestions: [],
      // /////////////
      qtags: [],
      selectedTags: [],
      tagOptions: [],
      tags: [],
      selectedCompany: [],
      companyOptions: [],
      questionProficiencyOptions: ["easy", "medium", "hard"],
      questionProficiency: undefined,
      questionBankTagOptions: [],
      selectedQuestionBankTags: [],
    }
  },
  created() {
    if (this.$route.name === "MCQStitcherEdit") {
      this.getStitchedMCQ()
      this.mode = "edit"
    } else if (this.$route.name === "MCQStitcherAdd") {
      this.mode = "add"
    }
    this.getMCQs()
    this.populateTags()
    this.populateCompany()
    this.populateQuestionBankTags()
  },
  methods: {
    getStitchedMCQ() {
      const { id } = this.$route.params
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          const { data } = res.data
          this.name = data.name
          window.pageTitle = `Edit - ${data.name}`
          this.time_allocated = data.time_allocated
          this.qtags = data.qtags
          this.selectedTags = data.qtags
          this.is_time_bound = data.is_time_bound
          this.id = data.id
          const tempSelectedQuestions = data.list.questions
          this.allAnswers = data.answers
          this.selectedCompany = data.company_questions.map((item) => ({
            id: item.company.id,
            name: item.company.name,
          }))
          this.questionProficiency = data.proficiency_level

          this.selectedQuestionBankTags = data.question_bank_tags.map(
            (item) => ({
              id: item.tag.id,
              name: item.tag.name,
            })
          )

          // we'll have both modified and unmodified question in selected list
          // so adding the required keys to make it look like unmodified
          // else it will error out during final stitching

          tempSelectedQuestions.forEach((q) => {
            const answerObj = this.allAnswers.find(
              (a) => q.question_id === a.question_id
            )
            const answer_ids = answerObj.answer_ids.map((answerId) => ({
              key: answerId,
            }))

            q.id = q.question_id
            q.content = q.title
            q.list = {}
            q.list.options = q.options
            q.answers = JSON.stringify(answer_ids)
          })
          this.selectedQuestions = tempSelectedQuestions
          this.selectedQuestions.forEach((question) => {
            this.markedQuestionIDs.push(question.question_id)
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          const tags = res.data.items
          this.tagOptions = tags.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        })
        .catch((err) => console.error(err))
    },
    populateCompany() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/company?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then((res) => {
        const companies = res.data.items
        this.companyOptions = companies.map((item) => ({
          id: item.id,
          name: item.name,
        }))
      })
      // this.selectedCompany =
    },
    populateQuestionBankTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}question_bank/tags?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then((res) => {
        const tags = res.data.items
        this.questionBankTagOptions = tags.map((item) => ({
          id: item.id,
          name: item.name,
        }))
      })
    },
    getDeletedTags() {
      const deletedTags = []
      for (let i = 0; i < this.qtags.length; i++) {
        if (
          !this.findElementInArray(
            this.qtags[i].name,
            this.selectedTags.map((item) => item.name)
          )
        ) {
          deletedTags.push(this.qtags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < deletedTags.length; i++) {
        finalTags.push(deletedTags[i].id)
      }
      return finalTags
    },
    getAddedTags() {
      const addedTags = []

      for (let i = 0; i < this.selectedTags.length; i++) {
        if (
          !this.findElementInArray(
            this.selectedTags[i].name,
            this.qtags.map((item) => item.name)
          )
        ) {
          addedTags.push(this.selectedTags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < addedTags.length; i++) {
        finalTags.push(addedTags[i].id)
      }
      return finalTags
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    stitchFinalQuestions() {
      // if (this.markedQuestionIDs.length <= 2) {
      //     alert("Please select multiple questions, invalid number")
      //     return;
      // }
      let sumOfPoints = 0
      const finalQuestions = []
      for (let i = 0; i < this.markedQuestionIDs.length; i++) {
        for (let j = 0; j < this.selectedQuestions.length; j++) {
          if (this.markedQuestionIDs[i] === this.selectedQuestions[j].id) {
            finalQuestions.push(this.selectedQuestions[j])
          }
        }
      }

      const answerArray = []
      const questionArray = []
      const attachmentList = []
      for (let i = 0; i < finalQuestions.length; i++) {
        // /Attachments
        if (finalQuestions[i].attachments) {
          for (let j = 0; j < finalQuestions[i].attachments.length; j++) {
            attachmentList.push(finalQuestions[i].attachments[j])
          }
        }

        // //
        /* this check is necessary as value of list key is by default in json
        format, but inside of GET we're modifying previously selected question
         where list is being initiated with an empty object */

        let qList
        if (typeof finalQuestions[i].list === "string") {
          qList = JSON.parse(finalQuestions[i].list)
        } else {
          qList = finalQuestions[i].list
        }
        questionArray.push({
          order: i + 1,
          question_id: finalQuestions[i].id,
          title: finalQuestions[i].content,
          explain: finalQuestions[i].explain,
          options: qList.options,
          points: finalQuestions[i].points,
        })
        sumOfPoints += finalQuestions[i].points

        const answerObj = {}
        answerObj.question_id = finalQuestions[i].id

        const tempAnswers = []

        // parsing answers key as it's in json format
        const answers = JSON.parse(finalQuestions[i].answers)
        for (let k = 0; k < answers.length; k++) {
          tempAnswers.push(answers[k].key)
        }
        answerObj.answer_ids = tempAnswers
        answerArray.push(answerObj)
      }

      const qObj = {
        answers: answerArray,
        attachments: attachmentList,
        is_time_bound: this.is_time_bound,
        time_allocated: this.time_allocated,
        content: "",
        is_dependent_ids: "[]",
        is_required: false,
        item_cursor: 0,
        list: {
          explain: "Some answer",
          has: "multiple",
          questions: questionArray,
        },
        name: this.name,
        points: sumOfPoints,
        reading_time: 0,
        tries: 0,
        type: 0,
        ops_qtags_unlink: this.getDeletedTags(),
        ops_qtags: this.getAddedTags(),
        companies: this.selectedCompany.map((item) => item.id),
        proficiency_level: this.questionProficiency,
        question_bank_tags: this.selectedQuestionBankTags.map(
          (item) => item.id
        ),
      }
      this.udpateQuestionData(qObj)
    },
    udpateQuestionData(qObj) {
      let url
      let method
      if (this.mode === "add") {
        url = `${siteConfig.siteURL}questions/`
        method = "post"
      } else if (this.mode === "edit") {
        url = `${siteConfig.siteURL}questions/${this.id}`
        method = "put"
      }
      this.axios({
        method,
        url,
        data: qObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/mcq-stitched/")
      })
    },
    markQuestionForStitching(id, question) {
      if (!this.checkIfIDExistsInArray(id)) {
        this.markedQuestionIDs.push(id)
        question.question_id = question.id
        this.selectedQuestions.push(question)
      }
    },
    unmarkQuestionForStitching(id) {
      const index = this.markedQuestionIDs.indexOf(id)
      this.selectedQuestions = this.selectedQuestions.filter(
        (q) => q.question_id !== id
      )
      if (index > -1) {
        this.markedQuestionIDs.splice(index, 1)
      }
    },
    checkIfIDExistsInArray(id) {
      for (let i = 0; i < this.markedQuestionIDs.length; i++) {
        if (this.markedQuestionIDs[i] === id) {
          return true
        }
      }
      return false
    },
    gotoPage(e) {
      const pageNo = parseInt(e.target.textContent)
      this.page = pageNo
      this.getMCQs()
    },
    getMCQs() {
      const loader = this.$loading.show()
      this.url = `${siteConfig.siteURL}admin/questions?search_by_type=1&fields=id,name,answers,list,points,qtags,content,explain,attachments&page=${this.page}&per_page=${this.per_page}`

      if (this.search_by_qtag) {
        this.search_by_qtag.forEach((tag) => {
          this.url = `${this.url}&search_by_qtagid=${tag.id}`
        })
      }

      this.axios({
        method: "get",
        url: this.url,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          this.totalPages = res.data.pages
          let responseArr = res.data.items
          responseArr = responseArr.filter((item) => item.list && item.answers)
          this.questions = responseArr
          loader.hide()
        })
        .catch((err) => console.error(err))
    },
  },

  /**  //// MCQ Stitched question JSON schema as given to me by Chirag - 13 June 2018
     * {
    "answers": [
        {
        "question_id": "qid1",
        "answers_ids": [
            "id1",
            "id2"
        ]
        },
        {
        "question_id": "qid2",
        "answers_ids": [
            "id3121"
        ]
        },
        {
        "question_id": "qid3",
        "answers_ids": [
            "id212112",
            "id3aasa121"
        ]
        }
    ],
    "attachments": {},
    "content": "",
    "is_dependent_ids": "[]",
    "is_required": false,
    "item_cursor": 0,
    "list": {
        "explain": "Some answer",
        "has": "multiple",
        "questions": [
        {
            "order": 1,
            "question_id": "qid1",
            "title": "Question 1 title",
            "explain": "Here is an explaination",
            "answers": [
            {
                "attachments": {},
                "id": "id1",
                "item": "HTML"
            },
            {
                "attachments": {},
                "id": "id2",
                "item": "CSS"
            },
            {
                "attachments": {},
                "id": "id3",
                "item": "JS"
            }
            ]
        },
        {
            "order": 2,
            "question_id": "qid2",
            "title": "Question 2 title",
            "explain": "Here is an other explaination",
            "answers": [
            {
                "attachments": {},
                "id": "id332",
                "item": "HTML 2"
            },
            {
                "attachments": {},
                "id": "id2aww",
                "item": "CSS 2"
            },
            {
                "attachments": {},
                "id": "id3121",
                "item": "JS 2"
            }
            ]
        },
        {
            "order": 3,
            "question_id": "qid3",
            "title": "Question 3 title",
            "explain": "Here is an other other explaination",
            "answers": [
            {
                "attachments": {},
                "id": "id212112",
                "item": "HTML 3"
            },
            {
                "attachments": {},
                "id": "id3saasaww",
                "item": "CSS 3"
            },
            {
                "attachments": {},
                "id": "id3aasa121",
                "item": "JS 3"
            }
            ]
        }
        ]
    },
    "name": "STITCHED",
    "points": 0,
    "reading_time": 10,
    "tries": 0,
    "type": 0
    }
        */
}
</script>

<style>
.paddd-down {
  margin-bottom: 4px;
  padding-left: 4px;
}
.mcq-mark-button {
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 2px;
  padding: 4px;
  border: 1px solid green;
  background-color: #8bc34a;
  cursor: default;
}
.mcq-mark-button:hover {
  color: black;
}
.mcq-unmark-button {
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 2px;
  padding: 4px;
  border: 1px solid #f1655a;
  color: white;
  background-color: #f1655a;
  cursor: default;
}
.mcq-unmark-button:hover {
  color: black;
}
</style>
